import React from 'react';
import DashboardIframe from 'src/components/DashboardIframe';

const HomeManagementView = () => {
  return (
    <DashboardIframe
      path="/home-management"
      title="Seções da Home"
    />
  );
};

export default HomeManagementView;

